import { StrictMode } from 'react';
import { render } from 'react-dom';
import { AuthProvider } from 'react-oidc-context';
import { BrowserRouter as Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import { AnalyticsProvider } from '@shared-web-analytics/react/dist';

import App from './App';

import store from './redux/store';

import reportWebVitals from './reportWebVitals';

import './index.scss';

const clientId = process.env.REACT_APP_SSO_OAUTH_CLIENT_ID;
const openIdConnectUrl = process.env.REACT_APP_SSO_URL;
const redirectUri = process.env.REACT_APP_SSO_REDIRECT_URL;
const scope = process.env.REACT_APP_SSO_OAUTH_SCOPE;

const oidcConfig = {
  authority: openIdConnectUrl,
  client_id: clientId,
  redirect_uri: redirectUri,
  scope
};

render(
  <StrictMode>
    <AuthProvider {...oidcConfig}>
      <Provider store={store}>
        <AnalyticsProvider>
          <Router>
            <App />
          </Router>
        </AnalyticsProvider>
      </Provider>{' '}
    </AuthProvider>
  </StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
